import React, { Component } from "react";
import { Form, Input, Select } from "antd";
import { connect } from "react-redux";
import { withRouter, RouteComponentProps } from "react-router-dom";
import style from "./navigation.module.sass";
import { Http } from "../../helpers/axois";
import { pushToast } from '../../stateManager/store/toast/actions'
import { AppState } from "../../stateManager/store";

const { Option } = Select;

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 }
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 }
  }
};

interface State {
  branchName: string
  parentBranch: any
  parentVersion: any
  error: any
  versionList: any
}

interface Props {
  onSubmit?: (submit: () => void) => void;
  appId?: any;
  getBranches?: () => void;
  pushToast?: (data: any) => void;
  // adding passed version id from form creation page since version gets wrongly set while navigating from that page alone
  currentBranch?: any;
  branchList?: any;
  versionData?: any;
  branchData?: any;
  versionList?: any;
  orgPermissions: any;
  loggedInUser:any;
  selectedOrg:any;
}

class BranchForm extends Component<RouteComponentProps & Props, State> {
  constructor(props: any) {
    super(props);
    this.state = {
      branchName: '',
      parentBranch: this.props.branchData ? {
        branch_id: this.props.branchData && this.props.branchData.branchId,
        branch_name: this.props.branchData && this.props.branchData.branchName
      } : {},
      parentVersion: this.props.versionData ? this.props.versionData : {},
      error: {},
      versionList: this.props.versionList ? this.props.versionList : []
    };
    this.props.onSubmit!(this.onSubmit);
  }

  componentDidUpdate(prevProp: any) {
    if (((prevProp.branchData && prevProp.branchData.branchId) !== (this.props.branchData && this.props.branchData.branchId))
      && ((prevProp.versionData && prevProp.versionData.version_id) !== (this.props.versionData && this.props.versionData.version_id))) {
      this.setState({
        parentBranch: {
          branch_id: this.props.branchData && this.props.branchData.branchId,
          branch_name: this.props.branchData && this.props.branchData.branchName
        },
        parentVersion: this.props.versionData ? this.props.versionData : {}
      })
    }
  }

  onSubmit = () => {
    let shouldModalClose = true;
    if (this.state.branchName && this.state.parentBranch && this.state.parentVersion) {
      this.createBranch()
    } else {
      const error: any = {}
      if (!this.state.branchName) error['branchNameErr'] = 'Required'
      if (!this.state.parentBranch.branch_id) error['parentBranchErr'] = 'Required'
      if (!this.state.parentVersion.version_id) error['parentVersionErr'] = 'Required'
      this.setState({
        error
      })
      shouldModalClose = false
    }
    return shouldModalClose
  };

  createBranch() {
    if ((!this.props?.orgPermissions?.includes("branch.Create") || !this.props.orgPermissions.includes('app.View'))&& this.props.loggedInUser?.id!=this.props.selectedOrg?.owner) {
      this.props.pushToast && this.props.pushToast(
        { type: 'error', message: "Not Authorized: Please request owner of this organization to provide access" })
      return
    } 
    // const currentBranchId = this.props.currentBranch && this.props.currentBranch[this.props.appId] && this.props.currentBranch[this.props.appId].branchId
    const data = {
      branchName: this.state.branchName,
      appId: this.props.appId,
      parentBranchId: this.state.parentBranch.branch_id,
      parentBranchName: this.state.parentBranch.branch_name,
      parentVersionCode: this.state.parentVersion.version_code,
    }
    Http.post('branch', data).subscribe((res: any) => {
      this.props.pushToast && this.props.pushToast(
        { type: 'success', message: 'Branch created successfully' }
      )
      this.props.getBranches && this.props.getBranches()
    }, (err: any) => {
      if (err === "Forbidden") {
        this.props.pushToast && this.props.pushToast(
          { type: 'error', message: "Not Authorized: Please request owner of this organization to provide access" })
      } else {
        this.props.pushToast && this.props.pushToast(
          { type: 'error', message: (err && err.message) ? err.message : "Branch creation failed" }
        )
      }
    })
  }

  render() {
    let { branchName, parentBranch, parentVersion, error } = this.state
    return (
      <div>
        <Form {...formItemLayout} className={'override-content'}>
          <Form.Item
            validateStatus={error.branchNameErr && "error"}
            help={error.branchNameErr}
            label={<span className={style.labelName}>Branch Name</span>}>
            <Input
              data-test-id="branch_name"
              value={branchName}
              onChange={e => this.setState({
                branchName: e.target.value.trim().replace(/ /g, "_"),
                error: {
                  ...this.state.error,
                  branchNameErr: ''
                }
              })}
            />
          </Form.Item>
          <Form.Item
            validateStatus={error.parentBranchErr && "error"}
            help={error.parentBranchErr}
            label={<span className={style.labelName}>Parent Branch</span>}>
            <Select
              data-test-id="parent_branch_name"
              style={{ width: '100%' }}
              value={parentBranch.branch_name}
              onChange={(e: any) => {
                const selectedBranch: any = this.props.branchList.find((branch: any) => branch.branch_name === e)
                this.setState({
                  parentBranch: selectedBranch,
                  parentVersion: {},
                  error: {
                    ...this.state.error,
                    parentBranchErr: ''
                  },
                  versionList: []
                })
                Http.get(`versions/${this.props.appId}?branchId=${selectedBranch.branch_id}`).subscribe((res: any) => {
                  this.setState({
                    versionList: res
                  })
                })
              }}>
              {this.props.branchList.length > 0 &&
                this.props.branchList.map((branch: any) =>
                (<Option data-test-id={`${branch.branch_name}`} key={branch.branch_id} value={branch.branch_name}>
                  {branch.branch_name}
                </Option>)
                )}
            </Select>
          </Form.Item>
          <Form.Item
            validateStatus={error.parentVersionErr && "error"}
            help={error.parentVersionErr}
            label={<span className={style.labelName}>Parent Version</span>}>
            <Select data-test-id="parent_version_id" style={{ width: '100%' }}
              value={parentVersion.version_id && `${parentVersion.version_tag}(${parentVersion.version_code})`}
              onChange={(e: any) => {
                const selectedVersion: any = this.state.versionList.find((version: any) => version.version_id === e)
                this.setState({
                  parentVersion: selectedVersion,
                  error: {
                    ...this.state.error,
                    parentVersionErr: ''
                  }
                })
              }}>
              {this.state.versionList.length > 0 &&
                this.state.versionList.map((version: any, index: number) =>
                (<Option data-test-id={`${version.version_tag}(${version.version_code})`} key={version.version_id} value={version.version_id}>
                  {`${version.version_tag}(${version.version_code})`}
                </Option>)
                )}
            </Select>
          </Form.Item>
        </Form>
      </div>
    );
  }
}
const mapStateToProps = (state: AppState, props: Props) => {
  return {
    orgPermissions: state.org.orgPermissions,
    selectedOrg: state.org.selectedOrg,
    loggedInUser:state.user.data.user
  }
};

export default withRouter(connect(
  mapStateToProps,
  { pushToast }
)(BranchForm));
